import { render, staticRenderFns } from "./propostasSidebar.vue?vue&type=template&id=0b33e0f5"
import script from "./propostasSidebar.vue?vue&type=script&lang=js"
export * from "./propostasSidebar.vue?vue&type=script&lang=js"
import style0 from "./propostasSidebar.vue?vue&type=style&index=0&id=0b33e0f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports